import { Button, message, Tooltip } from "antd";
import React, { Fragment, useEffect, useRef, useState } from "react";
import pause from "../../assets/icon/pause.svg";
import play from "../../assets/icon/play.svg";
import { HelperContext } from "../../store/helperStore";
import { RecorderContext } from "../../store/recorderStore";
import "./testQues.scss";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderIcon from "../../assets/icon/placeholderIcon.png";
export default function TestQues({ type, question }) {
  const {
    que_hint,
    que_title1,
    link1,
    link1_type,
    que_title2,
    link2,
    link2_type,
    section_name,
    replay,
    info_audio,
    test_format,
  } = question;

  const elementImg = useRef();
  const elementContent = useRef();

  const { helperC, dispatchHelper } = HelperContext();
  const { isAudioEnded } = helperC;

  const isFNMathTest = test_format === "dummy-test";
  console.log("test_format", isFNMathTest);
  console.log("test_format", test_format);
  // const withQuesHint = question.section_name !== "MEMORY RECALL";

  // shows how the question will looks
  useEffect(() => {
    const offsetHeight = elementImg.current
      ? elementImg.current.offsetHeight
      : elementContent.current
      ? elementContent.current.offsetHeight
      : 0;
    dispatchHelper({ type: "OFF_HEIGHT", payload: offsetHeight });
  }, []);

  const getImg = (src, isBig) => {
    return (
      <LazyLoadImage
        placeholderSrc={placeholderIcon}
        alt=""
        effect="blur"
        src={src}
      />
    );
  };

  const handleQuestionPortion1And2 = (
    que_title,
    link,
    link_type,
    bigger = false
  ) => {
    if (que_title || link) {
      if (bigger) {
        //que_title1 has to be bold
        return que_title ? (
          <>
            {replay === "Y" ? (
              <p
                className="ques-description"
                ref={elementContent}
                dangerouslySetInnerHTML={{ __html: que_title }}
              ></p>
            ) : !isAudioEnded ? (
              <p>Question will be revealed after you hear the audio</p>
            ) : (
              <p
                className=""
                ref={elementContent}
                dangerouslySetInnerHTML={{ __html: que_title }}
              />
            )}
          </>
        ) : link_type === "image" ? (
          <div className="test-ques-img wrapper">
            <div className="test-ques-img" ref={elementImg}>
              {getImg(link, false)}
            </div>
          </div>
        ) : link_type === "big-image" ? (
          <div className="multi-tap-ques-img" ref={elementImg}>
            {getImg(link, true)}
          </div>
        ) : replay === "Y" ? (
          <>
            <AudioClip
              URL={link}
              isAudioEnded={isAudioEnded}
              dispatchHelper={dispatchHelper}
              timerControl={false}
              replay={true}
            />
          </>
        ) : (
          <AudioClip
            URL={link}
            isAudioEnded={isAudioEnded}
            dispatchHelper={dispatchHelper}
            timerControl={true}
            replay={false}
          />
        );
      } else {
        return que_title ? (
          <>
            {replay === "Y" ? ( // replay y is in audio test
              <p
                className={isFNMathTest ? "FNMathTest" : ""}
                ref={elementContent}
                dangerouslySetInnerHTML={{ __html: que_title }}
              ></p>
            ) : !isAudioEnded ? (
              <p>Question will be revealed after you hear the audio</p>
            ) : (
              <p
                className={isFNMathTest ? "FNMathTest" : ""}
                ref={elementContent}
                dangerouslySetInnerHTML={{ __html: que_title }}
              />
            )}
          </>
        ) : link_type === "image" ? (
          <div className="test-ques-img wrapper">
            <div className="test-ques-img" ref={elementImg}>
              {getImg(link, false)}
            </div>
          </div>
        ) : link_type === "big-image" ? (
          <div className="multi-tap-ques-img" ref={elementImg}>
            {getImg(link, true)}
          </div>
        ) : replay === "Y" ? (
          <>
            <AudioClip
              URL={link}
              isAudioEnded={isAudioEnded}
              dispatchHelper={dispatchHelper}
              timerControl={false}
              replay={true}
            />
          </>
        ) : (
          <>
            <AudioClip
              URL={link}
              isAudioEnded={isAudioEnded}
              dispatchHelper={dispatchHelper}
              timerControl={true}
              replay={false}
            />
          </>
        );
      }
    } else {
      return null;
    }
  };

  return (
    <>
      {info_audio === "sound_differentiation" ? (
        <>
          <div className="soundDiff">
            <div className="soundDiff-audio-clip">
              <AudioClip
                URL={
                  require(`../../helper/constant/soundDiff/${que_title1.toLowerCase()}.mp3`)
                    .default
                }
                isAudioEnded={isAudioEnded}
                dispatchHelper={dispatchHelper}
                timerControl={false}
                replay={true}
              />
              <AudioClip
                URL={
                  require(`../../helper/constant/soundDiff/${que_title2.toLowerCase()}.mp3`)
                    .default
                }
                isAudioEnded={isAudioEnded}
                dispatchHelper={dispatchHelper}
                timerControl={false}
                replay={true}
              />
            </div>
            <h3 className="">Are the words spoken...?</h3>
          </div>
        </>
      ) : (
        <>
          <div className="question-format-one">
            {handleQuestionPortion1And2(que_title1, link1, link1_type)}
            {/* {que_hint && withQuesHint && (
            <p dangerouslySetInnerHTML={{ __html: que_hint }}></p>
          )} */}
          </div>

          <div className="question-format-two">
            {handleQuestionPortion1And2(que_title2, link2, link2_type, true)}
          </div>
        </>
      )}
    </>
  );
}

const AudioClip = ({
  URL,
  isAudioEnded,
  dispatchHelper,
  replay = true,
  timerControl = false,
}) => {
  const [playing, toggle] = useAudio(URL, dispatchHelper, timerControl, replay);
  const { recorderC, dispatchRecorder } = RecorderContext();

  return (
    // isAudioEnded is default false and true only is case of audio replay N cases to prevent replay
    <Tooltip
      title={
        !replay && playing // reply n case pause not allowed
          ? "Pause not allowed"
          : isAudioEnded // reply n case replay not allowed
          ? "Replay not allowed"
          : recorderC.isRecording
          ? "Please stop recording"
          : undefined
      }
    >
      <Button
        onClick={isAudioEnded || recorderC.isRecording ? undefined : toggle}
        className={`audio-player ${isAudioEnded && "disabled"}`}
      >
        {playing ? (
          <img src={pause} alt="" className="pause-icon" />
        ) : (
          <img src={play} alt="" className={`play-icon`} />
        )}
      </Button>
    </Tooltip>
  );
};

const useAudio = (url, dispatchHelper, timerControl, replay) => {
  // timer control do not let helper store update
  const { helperC } = HelperContext();
  const { recorderC, dispatchRecorder } = RecorderContext();
  const [audio, setAudio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);

  // replay only allow in replay Y cases audio
  const toggle = () => {
    setPlaying(replay ? !playing : true);
  }; // true);

  useEffect(() => {
    // PLAYING CAN BE TRUE OR FALSE
    if (playing) {
      var playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {
            dispatchRecorder({ type: "AUDIO_CLIP_STAT", payload: playing });
            audio.addEventListener("ended", () => {
              timerControl &&
                dispatchHelper({ type: "IS_AUDIO_ENDED", payload: true });
              setPlaying(false);
              dispatchRecorder({ type: "AUDIO_CLIP_STAT", payload: false });
            });

            audio.addEventListener("pause", () => {
              // timerControl &&
              //   dispatchHelper({ type: "IS_AUDIO_ENDED", payload: true });
              setPlaying(false);
              dispatchRecorder({ type: "AUDIO_CLIP_STAT", payload: false });
            });
          })
          .catch((error) => {
            //reloading audio
            setPlaying(false);
            setAudio(new Audio(url));
            console.log(error);
            message.info(
              "Play the audio again, there is some audio play issue"
            );
          });
      }
    }
    !playing && audio.pause();

    //if user tap the play button after timer start automatically timer should be pause
    if (playing) {
      timerControl && dispatchHelper({ type: "AUDIO_QUE_PLAY", payload: true });
      //handle alert msg
    } else {
      timerControl &&
        dispatchHelper({ type: "AUDIO_QUE_PLAY", payload: false });
    }

    return () => {
      audio.pause();
    };
  }, [playing]);

  useEffect(() => {
    helperC.isNextQues && audio.pause();
  }, [helperC.isNextQues]);

  useEffect(() => {
    setPlaying(false);
    audio.addEventListener("ended", () => {
      timerControl && dispatchHelper({ type: "IS_AUDIO_ENDED", payload: true });
      setPlaying(false);
      dispatchRecorder({ type: "AUDIO_CLIP_STAT", payload: false });
    });

    audio.addEventListener("pause", () => {
      // timerControl && dispatchHelper({ type: "IS_AUDIO_ENDED", payload: true });
      setPlaying(false);
      dispatchRecorder({ type: "AUDIO_CLIP_STAT", payload: false });
    });

    return () => {
      audio.removeEventListener("ended", () => {
        timerControl &&
          dispatchHelper({ type: "IS_AUDIO_ENDED", payload: true });
        setPlaying(false);
        dispatchRecorder({ type: "AUDIO_CLIP_STAT", payload: false });
      });
      audio.addEventListener("pause", () => {
        // timerControl &&
        //   dispatchHelper({ type: "IS_AUDIO_ENDED", payload: true });
        setPlaying(false);
        dispatchRecorder({ type: "AUDIO_CLIP_STAT", payload: false });
      });
    };
  }, []);

  return [playing, toggle];
};
